/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Register_SubmitInputs */



/**
* | output |
* | --- |
* | "Register" |
*
* @param {Developer_Register_SubmitInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_register_submit = /** @type {((inputs?: Developer_Register_SubmitInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Register_SubmitInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registrar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Registrar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registra")
	return /** @type {LocalizedString} */ ("Register")
});